import {AbstractInteraction, InteractionState} from "../abstract-interaction";
import {Feature, GeoJSON} from "geojson";

export class ViewSimpleSelect<T extends InteractionState> extends AbstractInteraction<T> {
  buildInitialState(initialState: T): any {
    if (initialState.features?.size) {
      initialState.features.forEach(feature => {
        if (feature.properties?.id && !feature.id) feature.id = feature.properties.id
        this.displayDrawFeature(this.createFeature(feature))
      });
    }
    return {
      ...super.buildInitialState(initialState),
      boxSelectStart: undefined,
      boxElement: undefined,
      boxSelectStartCoordinates: undefined,
      useOutlineSelect: true,
    };
  }

  canSave(state: T): boolean {
    return state.isDirty;
  }

  display(state: any, geojson: GeoJSON & Feature, display: (geojson: GeoJSON) => void): any {
    switch (geojson.geometry.type) {
      case 'Polygon':
      case 'MultiPolygon':
        geojson.properties._showArea = this.controller.interaction.hasArea();
        geojson.properties._showVertexLength = this.controller.interaction.hasVertexLength();
        geojson.properties._showAngle = this.controller.interaction.hasAngle();
        if (!state.useOutlineSelect) {
          break;
        }
        let layerGeometry = this.controller.interaction.getLayerGeometry(geojson.properties.id);
        if (layerGeometry?.document) {
          geojson.properties.selection = layerGeometry.document.properties.selection ?? 'fill'; /* || 'outline' */
          geojson.properties.focusStyle = !!layerGeometry.document.properties?.styleFocus?.isActive;
        }
        break;
      case 'LineString':
      case 'MultiLineString':
        geojson.properties._showLength = this.controller.interaction.hasLength();
        geojson.properties._showVertexLength = this.controller.interaction.hasVertexLength();
        geojson.properties._showAngle = this.controller.interaction.hasAngle();
        break;

    }
    return super.display(state, geojson, display);
  }

  async onMouseDown(state: any, e: mapboxgl.MapMouseEvent): Promise<void> {
    if (this.commonSelectors.isShiftMousedown(e)) {
      this.controller.mapInstance.dragPan.disable();
      state.boxSelectStart = e.originalEvent;
      state.boxSelectStartCoordinates = e.lngLat;
    }
    else this.controller.mapInstance.dragPan.enable();
  }


  async onMouseUp(state: any, e: mapboxgl.MapMouseEvent): Promise<void> {
    if (state.boxSelectStart) {
      this.controller.mapInstance.dragPan.enable();
      state.boxElement?.parentNode?.removeChild(state.boxElement)
      state.boxElement = undefined;
      let bbox = [this.mouseEventPoint(state.boxSelectStart), this.mouseEventPoint(e.originalEvent)];
      let bounds = [
        state.boxSelectStartCoordinates.lng < e.lngLat.lng ? state.boxSelectStartCoordinates.lng : e.lngLat.lng,
        state.boxSelectStartCoordinates.lat < e.lngLat.lat ? state.boxSelectStartCoordinates.lat : e.lngLat.lat,
        state.boxSelectStartCoordinates.lng < e.lngLat.lng ? e.lngLat.lng : state.boxSelectStartCoordinates.lng,
        state.boxSelectStartCoordinates.lat < e.lngLat.lat ? e.lngLat.lat : state.boxSelectStartCoordinates.lat,
      ];


      this.controller.mapInstance.fire("draw.boxSelect", {bbox, bounds});
      state.boxSelectStart = undefined;
    }
  }

  async onDrag(state: any, e: mapboxgl.MapMouseEvent): Promise<void> {

    if (state.boxSelectStart) {
      this._drawBoxSelect(state, e);
    }
  }

  private _drawBoxSelect(state: any, e: mapboxgl.MapMouseEvent) {
    if (!state.boxElement) {
      state.boxElement = document.createElement('div');
      state.boxElement.classList.add('mapbox-gl-draw_boxselect');
      this.controller.mapInstance.getContainer().appendChild(state.boxElement);
    }

    let boxSelectStart = this.mouseEventPoint(state.boxSelectStart);

    const current = this.mouseEventPoint(e.originalEvent);
    const minX = Math.min(boxSelectStart.x, current.x);
    const maxX = Math.max(boxSelectStart.x, current.x);
    const minY = Math.min(boxSelectStart.y, current.y);
    const maxY = Math.max(boxSelectStart.y, current.y);
    const translateValue = `translate(${minX}px, ${minY}px)`;
    state.boxElement.style.transform = translateValue;
    state.boxElement.style.WebkitTransform = translateValue;
    state.boxElement.style.width = `${maxX - minX}px`;
    state.boxElement.style.height = `${maxY - minY}px`;
  }

  async onClick(state: T, e: mapboxgl.MapMouseEvent){

      super.onClick(state,e);
  }

}
